<template>
    <div class="renewdetails">
        <helpInfo :helpData="helpData">
            <div slot="slotR"
                 class="back-div"
                 @click="$router.go(-1)">
                <Icon type="ios-arrow-dropleft"
                      size="16" />
                <span>{{$t('返回')}}</span>
            </div>
        </helpInfo>
        <div class="details"
             v-if="!isCountdown">
            <!--不续费提示语-->
            <div class="hint"
                 v-if="type==='noRenew'">
                <i class="icon-prompt-1-o"></i>
                <div class="hintFont">
                    <p>{{$t('1.到期不续费的资源，到期前不再进行续费提醒，请您谨慎选择。')}}</p>
                    <p>{{$t('2.已选择到期不续费的资源可以重新调整续费设置。')}}</p>
                </div>
            </div>
            <!--自动续费提示语-->
            <div class="hint"
                 v-if="type==='automatic'">
                <i class="icon-prompt-1-o"></i>
                <div class="hintFont">
                    <p>{{$t('1.设置为自动续费的资源，在到期的前7天会进行自动续费，如有其他规划请提前进行操作。')}}</p>
                    <p>{{$t('2.如果是到期时间在7天之内的资源，设置后会马上进行续费操作。')}}</p>
                </div>
            </div>
            <div class="top-productDesc"
                 v-if="type==='capacityChange'">
                <div class="left">
                    <img src="@/assets/images/console/hpc.png"
                         v-if="['HPC-DRP'].includes(productType)" />
                </div>
                <div class="right"
                     v-if="['HPC-DRP'].includes(productType)">
                    <p>1、{{$t('扩容、续订按照合同配置节点数量、单价、时长计算付款金额，不按照初始资源池价格计算。')}}</p>
                    <p>2、{{$t('删除节点时不退款，根据删除的节点数量补偿初始资源池使用时长。')}}</p>
                    <p>3、{{$t('删除节点时，每个资源池需要至少保留一个计算节点。')}}</p>
                    <p class="yellow">{{$t('注：扩容节点过期会删除扩容数量的节点，请注意计算节点作业信息，及时续订或者停止上传作业。')}}</p>
                </div>
            </div>
            <div class="top-productDesc"
                 v-if="type==='batch'">
                <div class="left">
                    <img src="@/assets/images/console/hpc.png"
                         v-if="['HPC-DRP','HPC'].includes(productType)" />
                    <img src="@/assets/images/console/modelarts.png"
                         v-else-if="['Modelarts','DRP','IAAS'].includes(productType)" />
                    <img src="@/assets/images/console/sfs.png"
                         v-else />
                </div>
                <div class="right"
                     v-if="['HPC-DRP'].includes(productType)">
                    <p>{{$t('1、续订时间在使用期内，则实际续订开始时间以上个周期订购截止时间进行续接，无任何其他费用。续费计算方式：月单价*续订月数。')}}</p>
                    <p>{{$t('2、如果续订时超过实际到期时间（未冻结），则结算时按照超过期限实际使用的天数进行补扣费用。补扣计算方式：每天价格(月单价/天数)*补扣区间')}}</p>
                    <p>{{$t('3、如果续订时超过实际到期时间（冻结状态下）且实际到期时间与冻结时间不一致，则结算时按照超过期限实际使用的天数进行补扣费用。补扣计算方式：每天价格(月单价/天数)*补扣区间')}}</p>
                    <p>{{$t('4、如果实际冻结时间与订购截止时间一致（已冻结），则正常续订，无需补扣款项。')}}</p>
                    <p>{{$t('5、续订专属资源池不涉及扩容节点，只续订初始资源。')}}</p>
                    <p class="yellow">{{$t('注：补扣计算时不包括任何折扣及优惠等，按照原价计算，天数为上月周期实际天数；补扣区间为实际使用的天数，不满一天按照一天算；总的补扣为各资源补扣费用之和。')}}</p>
                </div>
                <div class="right"
                     v-else-if="['DRP'].includes(productType)">
                    <p>{{$t('1.产品续订时按月进行收取金额。')}}</p>
                    <p>{{$t('2.如果产品已过期进行续订，需补扣过期时间金额（不足一天按一天计算）。')}}</p>
                    <p>{{$t('3.补扣费用为：补扣天数  * 每天价格(月单价/天数)。')}}</p>
                    <p>{{$t('补扣天数示例：')}}</p>
                    <p>{{$t('在2021年8月5日11:00订购产品，订购周期为3个月，截止时间为2021年11月5日11:00，总金额300元（每月100元）。')}}</p>
                    <p>{{$t('2021年11月15日12:00进行了续订操作，则补扣天数为：11天，11月5日11:00至11月16日11:00，费用为：补扣天数（11天） * 100（月单价）/31（周期月天数）。')}}</p>
                    <p>{{$t('2021年11月15日10:00进行了续订操作，则补扣天数为：10天，11月5日11:00至11月15日11:00，费用为：补扣天数（10天） * 100（月单价）/31（周期月天数）。')}}</p>
                </div>
                <div class="right"
                     v-else-if="['套餐包'].includes(productName)">
                    <p>{{$t('1.套餐包续订后立即生效，最终失效时间为根据续订的时间计算获得。')}}</p>
                    <p>{{$t('2.套餐包续订后无法进行退订。')}}</p>
                </div>
                <div class="right"
                     v-else-if="['SFS2.0'].includes(productType)">
                    <p>{{$t('1、续订时间在使用期内，则实际续订开始时间以上个周期订购截止时间进行续接，无任何其他费用。续费计算方式：月单价*续订月数。')}}</p>
                    <p>{{$t('2、如果续订时超过实际到期时间（未冻结），则结算时按照超过期限实际使用的天数进行补扣费用。补扣计算方式：每天价格(月单价/天数)*补扣区间')}}</p>
                    <p>{{$t('3、如果续订时超过实际到期时间（冻结状态下）且实际到期时间与冻结时间不一致，则结算时按照超过期限实际使用的天数进行补扣费用。补扣计算方式：每天价格(月单价/天数)*补扣区间')}}</p>
                    <p>{{$t('4、如果实际冻结时间与订购截止时间一致（已冻结），则正常续订，无需补扣款项。')}}</p>
                    <p class="yellow">{{$t('注：补扣计算时不包括任何折扣及优惠等，按照原价计算，天数为上月周期实际天数；补扣区间为实际使用的天数，不满一天按照一天算。')}}</p>
                </div>
                <div class="right"
                     v-else>
                    <p>{{currName}}</p>
                </div>
            </div>
            <Tabs :animated="false"
                  :closable="isClosable"
                  @on-click="tabClick"
                  @on-tab-remove="tabRemove"
                  size="small"
                  v-model="tabIndex"
                  :value="tabIndex">
                <TabPane v-for="(item, index) in renewList"
                         :label="$t(item.name || productName)"
                         :name="item.id"
                         :key="index + new Date().getTime()">
                </TabPane>
                <div class="confirm-container confirm-info">
                    <!-- 配置信息 -->
                    <div class="instance-item"
                         style="position: relative;">
                        <div class="left">
                            <h4>{{$t('配置信息')}}</h4>
                        </div>
                        <div class="right">
                            <!--详情-->
                            <!-- <CapacityDetail v-if="type==='capacityChange'"
                                            :detail="renewDetails" /> -->
                            <detailsPage v-if="isDetails&&tabIndex!==null&&productType!==null&&renewDetails!==null"
                                         :productType="productType"
                                         :productName="productName"
                                         :renewDetails="renewDetails">
                            </detailsPage>
                        </div>
                    </div>
                </div>
            </Tabs>
            <div class="confirm-container capacityChange-pack"
                 v-if="type==='capacityChange'">
                <Form ref="contractForm"
                      :model="formData"
                      :rules="rules"
                      :label-colon="true"
                      :hide-required-mark="false"
                      label-position="right"
                      :label-width="150">
                    <FormItem :label="$t('关联合同')"
                              prop="contractId"
                              :rules="{ required: true, message: this.$t('请选择'), trigger: 'change' }">
                        <Select style="width:220px;"
                                v-model="formData.contractId"
                                :transfer="true"
                                @on-change="getDataCapacity"
                                clearable>
                            <Option v-for="{contractTitle, contractId} in contractList"
                                    :key="contractId"
                                    :value="contractId">{{contractTitle}}</Option>
                        </Select>
                        <Tooltip theme="light"
                                 placement='right'
                                 :transfer='true'>
                            <i class="icon-prompt-1-o"
                               style="color:#2d8cf0; margin-left: 5px;"></i>
                            <div slot="content">
                                <span>{{$t('扩容请选择扩容合同，续订请选择续订合同')}}</span>
                            </div>
                        </Tooltip>
                    </FormItem>
                </Form>
            </div>
            <div class="confirm-container confirm-time"
                 v-if="type==='automatic'||type==='batch'">
                <!-- 数量&时长 -->
                <div class="instance-item"
                     style="border-bottom:0;">
                    <div class="left">
                        <h4>{{$t('续费信息')}}</h4>
                    </div>
                    <div class="right">
                        <Form ref="timeForm"
                              :model="formData"
                              :rules="rules"
                              :label-colon="true"
                              :hide-required-mark="false"
                              label-position="right"
                              :label-width="0">
                            <!-- 续费时长 -->
                            <FormItem v-if="type==='batch'&&renewDetails&&renewDetails.chargeType==='PrePaid'"
                                      style="margin-bottom: 5px;">
                                <!-- <span>{{$t('续费时长')}}：</span> -->
                                <template v-if="productName === '套餐包'">
                                    <RadioGroup type="button"
                                                v-model="formData.timeCount"
                                                @on-change="changeTimeCount">
                                        <!-- @on-change="getpackageData" -->
                                        <Radio v-for="(item,index) in timeList"
                                               :key="index"
                                               :label="item.period"
                                               border>{{item.period%12 === 0?item.period/12+$t('年'):item.period+$t('个月')}}</Radio>
                                    </RadioGroup>
                                </template>
                                <template v-else>
                                    <RadioGroup type="button"
                                                v-model="formData.timeCount"
                                                @on-change="changeTimeCount">
                                        <Radio v-for="(item,index) in productTimeList"
                                               :key="index"
                                               :label="item.value">{{$t(item.label)}}</Radio>
                                    </RadioGroup>
                                </template>
                                <p class="renewAfterTime">
                                    <span>{{$t('续费后到期时间')}}：</span> <b>{{renewAfterTime}}</b>
                                    <!-- <Tooltip placement="right"
                                             v-if="type === 'batch'"
                                             theme="light">
                                        <span class="rc-info-blue"
                                              style="margin-left:5px;">
                                            <i class="icon-prompt-1-o"
                                               style="color: #3498dc;"></i>
                                        </span>
                                        <div slot="content">
                                            <p>{{$t('实际续费时长=当前选择时长+续费到统一')}}</p>
                                            <p>{{$t('到期日需要补齐的时长（当前需要补齐的')}}</p>
                                            <p>{{$t('最大统一时长为')+days+$t('天')+"）"}}</p>
                                        </div>
                                    </Tooltip> -->
                                <div class="instruction"
                                     v-if="['DRP','IAAS'].includes(productType)">
                                    <p>{{$t('当对超期的订单进行续订时，需要对超期天数补扣费用')}}</p>
                                </div>
                                <!-- <div v-else-if="productName != '套餐包'"
                                     class="instruction">
                                    <p>{{$t('实际续费时长=当前选择时长+续费到统一')}}，{{$t('到期日需要补齐的时长（当前需要补齐的')}}{{$t('最大统一时长为')+days+$t('天')+"）"}}</p>
                                </div> -->
                            </FormItem>
                            <!--续费统一到期时间设置,私有云才显示-->
                            <!-- <FormItem style="margin-bottom: 15px;"
                                  v-show="!['SFS2.0'].includes(this.productType)">
                            <p class="expireDate">
                                <Checkbox v-model="formData.IsExpireDate"
                                          @on-change="endTimeFun">{{$t('统一到期时间设置为')}}</Checkbox>
                                <b>{{$t('每月')}}{{unifyDate}}{{$t('号')}}23:59:59</b>
                                <a @click="changeTime">{{$t('更改')}}</a>

                            </p>
                        </FormItem> -->
                            <!--续费使用优惠券-->
                            <FormItem v-if="type==='batch'&&showCoupon&&!notBilled"
                                      style="margin-bottom: 0px;">
                                <Checkbox v-model="formData.isCoupon"
                                          @on-change="changeCoupon">{{$t('使用优惠券')}}</Checkbox>
                                <template v-if="productName === '套餐包'">
                                    <Select style="width:200px;margin-left:20px;"
                                            v-if="formData.isCoupon"
                                            v-model="formData.couponId"
                                            :transfer="true"
                                            clearable
                                            @on-change="changeCouponValue">
                                        <Option v-for="(item, index) in couponData"
                                                :key="index"
                                                :disabled="item.reductionCondition> parseInt(packagequiryPrice)"
                                                :value="item.couponSid">{{item.text}}</Option>
                                    </Select>
                                </template>
                                <template v-else>
                                    <Select style="width:200px;margin-left:20px;"
                                            v-if="formData.isCoupon"
                                            v-model="formData.couponId"
                                            clearable
                                            :transfer="true"
                                            @on-change="changeCouponValue">
                                        <Option v-for="(item, index) in couponData"
                                                :key="index"
                                                :disabled="(item.discountAmount > parseInt(tradePrice)&&!['AI','DRP','HPC-DRP','IAAS','SFS2.0'].includes(productType))||item.reductionCondition> parseInt(tradePrice)"
                                                :value="item.couponSid">{{item.text}}</Option>
                                    </Select>
                                </template>
                            </FormItem>
                        </Form>
                    </div>
                </div>
            </div>

        </div>
        <div class="apply-footer"
             v-if="!isCountdown">
            <div class="footer-div">
                <!-- :style="['DRP', 'IAAS'].includes(this.productType)?'margin-top: 10px;':'line-height:60px'" -->
                <div class="balance">
                    <span class="config">
                        <template v-if="type === 'capacityChange'">
                            <span class="tit"
                                  style="margin-right: 7px;">{{$t('费用')}}:</span>
                            <span class="cost">
                                <span style="color:#f57d18;font-size:14px;">
                                    <span style="margin-right:20px;"><i style="color:#333;font-size:12px;font-style: normal;">{{$t('原价')}}：</i>{{$money(renewDetails.originalPrice||0,5)}}</span>
                                </span>
                                <span style="color:#f57d18;font-size:14px;">
                                    <span><i style="color:#333;font-size:12px;font-style: normal;">{{$t('实付金额')}}：</i>{{$money(notBilled ? 0 : renewDetails.tradePrice || 0,5)}}</span>
                                </span>
                            </span>
                        </template>
                        <template v-else-if="productName != '套餐包'">
                            <inquiry-price ref="inquiryPrice"
                                           operateTtype="renewal"
                                           :templateType="renewDetails.productCode"
                                           @refresh='refreshPrice'
                                           @notBilled="(status) => notBilled=status"></inquiry-price>
                        </template>
                        <template v-else>
                            <span class="tit">{{$t('费用')}}:</span>
                            <span class="cost"
                                  v-if="priceLoading">
                                <Icon type="ios-loading"
                                      size=16
                                      class="demo-spin-icon-load rc-color-orange"></Icon>
                                <span class="font-size14">
                                    {{$t('计算中')}}...
                                </span>
                            </span>
                            <span v-else
                                  class="cost">
                                <span style="color: #ff6a01;">{{$money(packagequiryPrice,5)}}</span>
                            </span>
                        </template>
                    </span>
                    <!-- <div class="tips"
                         v-if="['DRP', 'IAAS'].includes(this.productType)">{{$t('此为参考价格，具体扣费请以账单为准。扣费优先级为优惠券>抵扣现金券>充值现金券余额>现金余额>信用额度。')}}
                    </div> -->
                </div>
                <div class="btn-div">
                    <Button type="primary"
                            :disabled="!canSubmit || submitLoading"
                            :loading="loading"
                            @click="submit">{{loading? $t('保存中') : (type==='batch'?$t('立即续订'):$t('确定'))}}</Button>
                </div>
            </div>
        </div>
        <!-- 设置统一到期时间 -->
        <expirationtime ref="expirationtime"
                        @refresh="timeName" />
        <!--倒计时-->
        <countdown ref="countdown"
                   :txt="$t('提交成功')"
                   :jumpTxt="$t('我的订单')"
                   jumpLink="/mgt/order">
        </countdown>
        <discountmodal ref="discountmodal"
                       :titleTxt="$t('确定要继续购买吗？') "
                       :contentTxt="$t('您使用的优惠券金额大于订单金额，超出的优惠金额将不退还。')"
                       @modalFun="modalFun"></discountmodal>
    </div>
</template>

<script>
import helpInfo from '@c/basic/helpinfo'
import API from '@/service/api'
import inquiryPrice from '@c/console/inquiry-price'
import detailsPage from './detailsitem'
import expirationtime from './expirationtime'
import countdown from '@c/basic/countdown'
import { formatDateTime } from '@/service/utils'
import discountmodal from '@/views/portal/application/components/discountmodal.vue'
export default {
    name: 'renewdetails',
    components: {
        helpInfo,
        inquiryPrice,
        detailsPage,
        expirationtime,
        countdown,
        discountmodal
    },
    data () {
        return {
            helpData: {
                modelName: this.$t('续费')
            },
            noCouponTradePrice: 0,
            isClosable: true,
            count: '',
            canSubmit: false,
            currName: '',
            productName: '',
            isCoupon: false, // 是否启用优惠券
            isCountdown: false,
            days: 0,
            endTime: null, // 统一到期时间设置的结束时间
            frozenTime: null, // 冻结时间
            now: null, // endTime时间比当前时间小，计算时间传这个值
            renewAfterTime: null, // 续费后到期时间
            unifyDate: 1, // 统一时间
            couponData: [], // 符合满减条件的优惠券
            couponList: [], // 优惠券
            renewList: [], // 操作的续费列表
            tabIndex: null, // 资源ID
            productType: null, // 产品类别
            type: '', // 续费类型
            isDetails: true, // 切换续费详情
            loading: false,
            submitLoading: false, // 询价中
            priceData: null, // 询价详情
            inquiryJson: null, // 询价配置文件
            period: 0, // 续费时长
            renewDetails: {}, // 续费详情
            submitData: {
                price: 0,
                fixedPrice: 0, // 固定收费
                tradePrice: 0// 折扣价
            },
            formData: {
                timeCount: 1,
                isExpireDate: false, // 是否统一到期时间
                isCoupon: false, // 是否使用优惠券
                couponId: null, // 优惠券
                discount: null,
                packageId: null, // 套餐包id
                contractId: '' // 合同ID
            },
            clusterId: this.$route.query.cluster,
            HPCDRPServiceId: '',
            rules: {},
            timeList: [], // 套餐包时间t
            contractList: [],
            packagequiryPrice: 0, // 套餐包价格
            priceLoading: false,
            inquiryFlag: null, // 询价节流
            notBilled: false, // 不计费
            entityId: null // 实体id
        }
    },
    computed: {
        showCoupon () {
            // 可以使用优惠券的条件
            // 包年包月，金额大于0，公有云、私有云都可以，modelArts下产品
            const isPrePaid = this.renewDetails.chargeType === 'PrePaid'
            // 金额必须要大于0 && （私有云实例创建 || 第三方服务）
            const isEnvPrivateAndCompute = ['compute', 'floatingIp', 'disk', 'otherService'].includes(this.component) // 公有云，私有云都能使用优惠券，bug19753
            return this.productName === '套餐包' ? isPrePaid : (isEnvPrivateAndCompute || ['DRP', 'IAAS', 'SFS2.0', 'HPC-DRP', 'SFS2.0'].includes(this.productType)) && isPrePaid
        },
        tradePrice () {
            return this.submitData.tradePrice
        }
    },
    // 离开当前页面
    destroyed () {
        // 清除renewList
        // sessionStorage.removeItem('renewList')
    },
    created () {
        this.renewList = JSON.parse(sessionStorage.getItem('renewList'))
        if (!this.renewList) {
            this.$router.push({
                path: '/'
            })
            return
        }
        this.productType = this.$route.query.productType
        this.productName = this.$route.query.name
        this.currName = this.$route.query.name
        this.entityId = this.$route.query.entityId

        if (this.renewList.length === 1) {
            this.isClosable = false
        }
        this.init()
        if (this.productName === '套餐包') {
            this.getDatapackage(this.tabIndex)
        } else if (this.type === 'capacityChange') {
            this.getDataCapacity(this.tabIndex)
            this.getSontract()
        } else {
            this.getData(this.tabIndex, this.productType)
        }
        this.getUnifyDate()
        // this.changeCoupon()
        // this.getIsCoupon()
    },
    watch: {
        // tabIndex (val, old) {
        //     // 切换资源id重新查询
        //     if (val !== old && val !== null) {
        //         this.isDetails = false
        //         this.$nextTick(function () {
        //             this.getData(this.tabIndex, this.productType)
        //         })
        //     }
        // }
    },
    methods: {
        getBilledStatus () { // 用于判断是否不计费
            const { chargeType, serviceId } = this.renewDetails
            if (!(serviceId && chargeType) || !['HPC-DRP', 'SFS2.0', 'DRP'].includes(this.productType) || this.type !== 'capacityChange') return // 判断是否计费， 一次就够了
            this.notBilled = true
            this.axios.get(this.urlFormat(API.BILLING_ISNONBILLPRODUCT), {
                params: { sfServiceId: serviceId, chargeType: chargeType }
            }).then(res => {
                this.notBilled = res
            })
        },
        // 套餐包详情
        getDatapackage (id) {
            this.renewDetails = {}
            this.axios.get(this.urlFormat(API.GET_BAG_RENEW, false, [id])).then(res => {
                if (res) {
                    this.renewDetails = Object.assign({ chargeType: this.renewList[0].billingType, config: this.renewList[0], endTime: res.lastEndTime })
                    this.endTime = res.lastEndTime
                    this.timeList = res.spec[this.renewList[0].bagSpecName]
                    this.formData.timeCount = res.spec[this.renewList[0].bagSpecName][0].period
                    this.clusterId = res.spec[this.renewList[0].bagSpecName][0].clusterId
                    this.$nextTick(() => {
                        this.isDetails = true
                        this.endTimeFun()
                        this.getpackageData()
                    })
                }
            })
        },
        // 套餐包询价
        getpackageData () {
            const data = this.timeList.filter(item => item.period === this.formData.timeCount)[0] // 价格
            const curCoupon = this.couponList.find(item => item.couponSid === this.formData.couponId) // 优惠券
            this.formData.packageId = data.id
            // 限流，防止询价过快
            this.priceLoading = true
            if (!this.inquiryFlag) {
                this.inquiryFlag = setTimeout(() => {
                    this.inquiryFlag = null
                    const price = data.price - (curCoupon ? curCoupon.discountAmount : 0)
                    this.packagequiryPrice = price > 0 ? price : 0
                    this.priceLoading = false
                    if (this.quiryPrice !== null) {
                        this.canSubmit = true
                    }
                }, 500)
            }
        },
        // 查询详情
        getData (id, productType) {
            this.renewDetails = {}
            this.axios.get(this.urlFormat(API.RENEW_RESOURCR_DETAIL, false, [id]), { params: { productType } }).then(res => {
                this.renewDetails = res
                if (typeof res.config === 'string') {
                    const data = JSON.parse(res.config)
                    this.HPCDRPServiceId = res.serviceId
                    this.renewDetails.config = data
                }
                this.endTime = this.renewDetails.endTime
                this.frozenTime = this.renewDetails.frozenTime
                this.now = this.renewDetails.now
                this.inquiryJson = res.inquiryJson
                this.$nextTick(() => {
                    this.isDetails = true
                    this.endTimeFun()
                })
            })
        },
        // 查询扩容详情
        getDataCapacity () {
            const { productType, tabIndex: productResourceId } = this
            this.renewDetails = {}
            // productResourceId=389&proudctType=HPC-DRP&contractId=1519935054586056705
            this.axios.get(this.urlFormat(API.SERVICE_UPGRADEDETAIL, false), { params: { productResourceId, productType, contractId: this.formData.contractId } }).then(res => {
                const { chargeType, serviceId } = res.productInfoVOList[0] || {}
                this.renewDetails = Object.assign(res, { chargeType, serviceId, config: JSON.parse(res.productConfigDesc), endTime: res.endTime, productCode: 'HPC-DRP' })
                this.getBilledStatus()
                this.endTime = res.endTime
                this.$nextTick(() => {
                    this.isDetails = true
                    this.canSubmit = true
                })
            })
        },
        /**
        * 合同列表
        */
        getSontract () {
            this.axios.get(this.urlFormat(API.CONTRACT), {
                params: {
                    orgSid: this.$store.state.user.currentOrg.orgSid,
                    discountScopeList: ['hpc_open', 'hpc_renew'],
                    contractStatus: 'unused',
                    entityId: this.entityId,
                    clusterId: this.clusterId,
                    flag: true
                }
            }).then(res => {
                this.contractList = res
            })
        },
        // 初始化数据
        init () {
            this.tabIndex = null
            this.productType = null
            this.type = this.$route.query.type
            if (this.type === 'batch') {
                this.helpData.modelName = this.$t('续费设置')
            }
            if (this.type === 'automatic') {
                this.helpData.modelName = this.$t('自动续费设置')
            } else if (this.type === 'noRenew') {
                this.helpData.modelName = this.$t('设置不续费')
            } else if (this.type === 'capacityChange') {
                this.helpData.modelName = this.$t('扩容、续订设置')
            }
            const { id, productType } = this.renewList[0]
            this.tabIndex = id
            this.productType = productType
        },
        // tab切换
        tabClick (id) {
            this.tabIndex = id
            for (let i = 0; i < this.renewList.length; i++) {
                if (this.renewList[i].id === id) {
                    this.productType = this.renewList[i].productType
                    this.currName = this.renewList[i].productName
                }
            }
        },
        // 删除tab
        tabRemove (val) {
            this.renewList = this.renewList.filter(item => item.id !== val)
            if (this.renewList.length === 1) {
                this.isClosable = false
            }
            this.tabIndex = this.renewList[0].id
            this.productType = this.renewList[0].productType
        },
        // 获取统一时间
        getUnifyDate () {
            this.axios.get(
                this.urlFormat(API.RENEW_UNIFY_DATE, false))
                .then(res => {
                    this.unifyDate = res.unifyDate
                }).catch(e => {
                    console.log(e)
                })
        },
        // 更改到期时间
        changeTime () {
            // 设置统一到期日
            this.$refs.expirationtime.open(this.unifyDate)
        },
        // 设置统一到期时间
        timeName (data) {
            this.unifyDate = data
            this.endTimeFun()
        },
        // 是否启用优惠券
        changeCoupon () {
            this.couponData = []
            this.couponList = []
            this.formData.couponId = null
            this.formData.discount = null
            if (this.formData.isCoupon) {
                if (this.$isNullOrEmpty(this.couponData)) {
                    const time = new Date()
                    const params = {
                        categoryId: this.renewDetails.serviceId,
                        couponStatus: 'unused',
                        startTimeLe: time ? formatDateTime(time) : '',
                        endTimeGe: time ? formatDateTime(time) : ''
                    }
                    if (this.productName === '套餐包') {
                        params.clusterId = this.clusterId
                    }
                    this.axios.get(this.urlFormat(API.COUPONS_ACCOUNTS), {
                        params: params
                    }).then((result) => {
                        if (result.dataList && result.dataList.length > 0) {
                            this.couponList = result.dataList
                            this.couponValueFun()
                        } else {
                            this.changeCouponValue()
                        }
                    })
                }
            } else {
                this.changeCouponValue()
            }
        },
        getIsCoupon () {
            this.axios.get(this.urlFormat(API.GET_CONFIGS_COUPON_CONFIG, true)).then((res) => {
                for (let i = 0; i < res.length; i++) {
                    if (res[i].configKey === 'counpon.enabled' && res[i].configValue === '1') {
                        this.isCoupon = true
                    }
                }
            })
        },
        // 过滤优惠券
        couponValueFun () {
            const newList = this.couponList.filter((item) => {
                return item
                // return !item.reductionCondition || item.reductionCondition <= parseInt(this.submitData.tradePrice)
            })
            newList.forEach(item => {
                item.text = item.reductionCondition ? '（' + this.$t('满') + item.reductionCondition + this.$t('减') + item.discountAmount + '）' + this.$t('￥') + item.discountAmount + this.$t('优惠券') : '（' + this.$t('无限制') + '）' + this.$t('￥') + item.discountAmount + this.$t('优惠券')
            })
            this.couponData = newList
            // if (this.formData.couponId === null && newList.length > 0) {
            //     this.formData.couponId = newList[0].couponSid
            //     this.formData.discount = newList[0].discountAmount
            // }
            // this.changeCouponValue()
        },
        // 选择使用优惠券
        changeCouponValue () {
            const { couponId } = this.formData
            if (this.productName === '套餐包') {
                if (couponId && this.couponList.length) {
                    const curCoupon = this.couponList.find(item => item.couponSid === this.formData.couponId)
                    if (curCoupon && curCoupon.discountAmount > this.packagequiryPrice) {
                        this.$refs.discountmodal.openModal()
                    } else {
                        this.getpackageData()
                    }
                } else {
                    // 套餐包询价
                    this.getpackageData()
                }
            } else {
                if (couponId && this.couponList.length) {
                    const curCoupon = this.couponList.find(item => item.couponSid === this.formData.couponId)
                    if (curCoupon && curCoupon.discountAmount && ['AI', 'DRP', 'HPC-DRP', 'IAAS', 'SFS2.0'].includes(this.productType) && curCoupon.discountAmount > this.noCouponTradePrice) {
                        this.$refs.discountmodal.openModal()
                    } else {
                        this.inquiryPrice()
                    }
                } else {
                    this.inquiryPrice()
                }
            }
        },
        modalFun () {
            const data = this.getOne(this.formData.couponId, this.couponData, 'couponSid')
            this.formData.discount = data ? data.discountAmount : null
            this.$nextTick(() => {
                this.productName === '套餐包' ? this.getpackageData() : this.inquiryPrice()
            })
        },
        // 计算续费后到期时间
        endTimeFun () {
            let endTime = this.endTime
            if (['SFS2.0'].includes(this.productType) && this.renewDetails.status !== 'frozen' && this.now) {
                endTime = this.now
            }
            const data = {
                endTime: endTime,
                frozenTime: ['HPC-DRP', 'SFS2.0', 'DRP'].includes(this.productType) ? this.frozenTime : null,
                unifyDate: this.formData.IsExpireDate ? this.unifyDate : null,
                period: this.formData.timeCount
            }
            if (['DRP'].includes(this.productType)) {
                data.productCode = this.productType
            }
            this.axios.get(
                this.urlFormat(API.GET_RENEW_DATE, false),
                {
                    params: data
                })
                .then(res => {
                    this.renewAfterTime = res.endTime
                    this.period = res.period
                    this.days = Number(res.offset || 0)
                    this.$nextTick(() => {
                        this.productName === '套餐包' ? this.getpackageData() : this.inquiryPrice()
                    })
                }).catch(e => {
                    console.log(e)
                })
        },
        // 续费时长
        changeTimeCount () {
            this.endTimeFun()
            for (const i in this.timeList) {
                if (Number(this.timeList[i].period) === Number(this.formData.timeCount)) {
                    this.clusterId = this.timeList[i].clusterId
                }
            }
            // 清空优惠券
            this.formData.couponId = null
            this.formData.discount = null
        },
        // 询价
        async inquiryPrice (type, list) {
            this.submitLoading = true
            // this.couponData = []
            // this.formData.couponId = null
            // this.formData.discount = null
            this.priceData = null
            const params = JSON.parse(this.inquiryJson)
            params.period = this.period
            params.id = this.tabIndex
            params.couponId = this.formData.couponId
            // hpc-drp因为serviceId是数值类型，且parse溢出了，所以取外层字符型id
            if (params.productCode === 'HPC-DRP' && this.HPCDRPServiceId) {
                params.serviceId = this.HPCDRPServiceId
            }
            // params.endTime = this.endTime
            // if (this.formData.IsExpireDate) {
            //     params.unifyDate = this.unifyDate
            // }
            if (this.$refs.inquiryPrice) {
                // this.canSubmit =
                this.$refs.inquiryPrice.renewInquiry(params)
                this.submitLoading = false
            }
        },
        // 更新询价数据
        refreshPrice (data) {
            this.canSubmit = false
            if (data) {
                this.submitData.price = data.originalPrice
                this.submitData.fixedPrice = data.fixedPrice
                this.submitData.tradePrice = data.tradePrice
                this.priceData = data
                if (!this.formData.couponId) {
                    this.noCouponTradePrice = this.$deepClone(this.submitData.tradePrice)
                }
                if (data.originalPrice > 0) {
                    this.canSubmit = true
                } else if (data.billingPrices && data.billingPrices.length > 0) {
                    this.canSubmit = true
                }
            }
        },
        // 提交
        submit () {
            this.loading = true
            if (this.type === 'batch') {
                if (this.productName === '套餐包') {
                    const params = {
                        orderType: 'renew',
                        // type: this.submitData.zeroData.type,
                        quantity: 1,
                        couponId: this.formData.couponId, // 优惠券id
                        id: this.formData.packageId // 折扣id
                    }
                    //
                    this.axios.post(this.urlFormat(API.POST_BAG_RENEW, false), params, { headers: { showMsg: false } }).then(res => {
                        if (res === 'SUCCESS' || res.status) {
                            this.loading = false
                            this.isCountdown = true
                            this.$refs.countdown.goChoicePeople()
                        } else {
                            res.message && this.$Message.error({ content: res.message, duration: 5 })
                            this.loading = false
                        }
                    }).catch(() => {
                        this.loading = false
                    })
                } else {
                    // 获取名称
                    let name = this.productName
                    if (this.renewList.length && this.renewList.length > 0) {
                        for (const i in this.renewList) {
                            if (String(this.renewList[i].id) === String(this.tabIndex)) {
                                name = this.renewList[i].name
                            }
                        }
                    }
                    // 续费
                    const params = {
                        couponSid: this.formData.couponId,
                        productInfo: [
                            {
                                name: name,
                                productCode: this.renewDetails.productCode,
                                cloudEnvId: this.renewDetails.cloudEnvId,
                                regionId: this.renewDetails.resourceId,
                                id: this.tabIndex,
                                chargeType: this.renewDetails.chargeType,
                                period: this.period,
                                unifyDate: this.formData.IsExpireDate ? this.unifyDate : null,
                                /* 产品配置描述 */
                                productConfigDesc: JSON.stringify({
                                    /* 当前产品配置描述 */
                                    currentDesc: this.renewDetails.config,
                                    /* 变更配置描述 */
                                    changeDesc: [{
                                        label: 'period',
                                        oldValue: ['SFS2.0'].includes(this.productType) ? (this.now || this.endTime) : this.endTime,
                                        newValue: this.renewAfterTime
                                    }]
                                })
                            }
                        ]
                    }
                    this.axios.post(this.urlFormat(API.RENEW, false), params, { headers: { showMsg: false } }).then(res => {
                        if (res === 'SUCCESS' || res.status) {
                            this.loading = false
                            this.isCountdown = true
                            this.$refs.countdown.goChoicePeople()
                        } else {
                            res.message && this.$Message.error({ content: res.message, duration: 5 })
                            this.loading = false
                        }
                    }).catch(() => {
                        this.loading = false
                    })
                }
            } else if (this.type === 'capacityChange') { // 扩容
                this.$refs.contractForm.validate((valid) => {
                    if (!valid) {
                        this.loading = false
                        return
                    }
                    this.$Modal.confirm({
                        title: '确认提交申请？',
                        content: '请确认配置信息与合同签订一致',
                        onOk: () => {
                            const { productType, tabIndex: productResourceId } = this
                            this.axios.put(this.urlFormat(API.SERVICE_UPGRADE, false), {
                                productResourceId,
                                productType,
                                contractId: this.formData.contractId
                            }, { headers: { showMsg: false } }).then(res => {
                                if (res.status) {
                                    this.isCountdown = true
                                    this.$refs.countdown.goChoicePeople()
                                } else {
                                    res.message && this.$Message.error({ content: res.message, duration: 5 })
                                }
                                this.loading = false
                            }).catch(() => {
                                this.loading = false
                            })
                        },
                        onCancel: () => {
                            this.loading = false
                        }
                    })
                })
            } else {
                const ids = []
                for (let i = 0; i < this.renewList.length; i++) {
                    ids.push(this.renewList[i].id)
                }
                // 自动续费/不续费
                this.axios.put(this.urlFormat(API.PUT_RENEW_TYPE, false), {
                    ids: ids,
                    renewType: this.$route.query.renewType,
                    renewCycle: this.period
                }).then(res => {
                    this.loading = false
                    // 跳转到续费列表
                    this.$router.push({
                        path: '/mgt/renew'
                    })
                }).catch(() => {
                    this.loading = false
                })
            }
        }
    }
}
</script>
<style lang="less" scoped>
.confirm-container {
    .instance-item {
        background: #fff;
        padding: 15px 0px;
        min-height: 70px;
        h4 {
            padding: 10px 0 20px 36px;
            font-size: 12px;
        }
        .left {
            display: inline-block;
            width: 135px;
            float: left;
        }
        .right {
            display: inline-block;
            width: calc(~'100% - 135px');
            padding-top: 3px;
            .instruction {
                padding-top: 8px;
                color: #999999;
                line-height: 20px;
            }
        }
    }
    .instance-item-icon {
        position: relative;
        right: 6px;
        top: 2px;
        font-size: 14px;
    }
}
.renewdetails {
    position: relative;
    height: calc(~'100% - 26px');
    background: #f5f6f7;
    .expireDate {
        b {
            font-size: 12px;
            font-weight: 600;
            padding: 0 10px 0 5px;
            // color: #f57d18;
        }
    }
    .renewAfterTime {
        padding: 15px 0 0 0;
        b {
            color: #f57d18;
        }
    }
    .explanation {
        font-size: 12px;
        padding: 0 0 0 0px;
        color: #999;
    }
    .details {
        height: calc(~'100% - 100px');
        overflow-y: auto;
        padding: 15px 15px 15px 15px;
    }
    .apply-footer {
        width: 100%;
        height: 60px;
        background: #fff;
        margin: 0 auto;
        border-top: 1px solid #e9e9e9;
        position: absolute;
        right: 0;
        bottom: -22px;
        .footer-div {
            width: 100%;
            height: 60px;
            padding: 0 15px;
            margin: 0;
            display: flex;
            .balance {
                width: 70%;
                height: 60px;
                line-height: 60px;
                padding-left: 10px;
                .config {
                    display: inline-block;
                    width: 100%;
                }
                .tips {
                    line-height: 18px;
                    color: #999999;
                }
                .cost {
                    color: #f57d18;
                    font-size: 14px;
                }
            }
            .btn-div {
                width: 30%;
                height: 60px;
                line-height: 60px;
                text-align: right;
                padding-right: 4px;
                float: right;
            }
        }
    }
    .top-productDesc {
        // width: 1200px;
        margin: 0 auto;
        background: #fff;
        // margin-bottom: 10px;
        overflow: hidden;
        padding: 15px 0;
        clear: both;
        display: flex;
        .left,
        .right {
            display: flex;
            flex-direction: column;
            justify-content: center;
        }
        .left {
            width: 200px;
            img {
                max-width: 100%;
            }
        }
        .right {
            width: calc(~'100% - 200px');
            line-height: 24px;
            p.yellow {
                color: #ff8400;
            }
            p {
                padding-left: 40px;
            }
        }
    }
}
.confirm-container {
    overflow: hidden;
}
.confirm-container.confirm-info {
    .instance-item {
        min-height: 180px;
    }
}
.confirm-container.confirm-time {
    margin: 15px 0 0 0;
    .instance-item {
        padding: 15px 0px 15px 0px;
        min-height: 70px;
    }
}
.capacityChange-pack {
    padding: 15px;
    background-color: #fff;
}
</style>
<style lang="less">
.renewdetails {
    .ivu-tabs-bar {
        margin-bottom: 0px;
        background: #fff;
        border-bottom: 10px solid #f5f6f7 !important;
        border-top: 1px solid rgb(243, 243, 243) !important;
    }
    .ivu-tabs-mini .ivu-tabs-tab {
        padding: 15px 16px !important;
    }
}
</style>
